import { tv } from '~/utils/tv'

const popoverStyles = tv({
  slots: {
    root: [
      'min-w-[240px] max-w-[480px] rounded-[var(--border-radius-largecontainer)] bg-[var(--color-fill-neutral-default)] p-fourpulse shadow-[0px_2px_8px_#71768E] ring-[length:var(--border-width-quarterpulse)] ring-[var(--color-border-neutral-default)]',
    ],
    title: [
      'line-clamp-2 overflow-hidden text-ellipsis pt-twopulse font-bold font-rdmodern text-[var(--color-text-neutral-default)] text-threeandhalfpulse leading-small tracking-default',
    ],
    description: [
      'line-clamp-3 pt-twopulse font-rdmodern font-regular text-[var(--color-text-neutral-default)] text-threepulse leading-medium tracking-default',
    ],
    buttonDescription: [
      'line-clamp-3 pt-twopulse font-rdmodern font-regular text-[var(--color-text-neutral-default)] text-threepulse leading-medium tracking-default',
    ],
  },
})

export const { root, title, description, buttonDescription } = popoverStyles()
